import { useEffect, useRef, useState } from 'react';

const usePolling = (callback, intervalMs, dependencies = []) => {
  const savedCallback = useRef(callback);
  const [isSyncing, setIsSyncing] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    if (!intervalMs || typeof savedCallback.current !== 'function') {
      return undefined;
    }

    let active = true;
    let timeoutId = null;

    const tick = async () => {
      if (!active) return;
      
      setIsSyncing(true);
      try {
        await savedCallback.current();
        setError(null);
      } catch (err) {
        console.error('Polling error:', err);
        setError(err);
      } finally {
        setIsSyncing(false);
        if (active) {
          timeoutId = window.setTimeout(tick, intervalMs);
        }
      }
    };

    tick();

    return () => {
      active = false;
      if (timeoutId) {
        window.clearTimeout(timeoutId);
      }
    };
  }, [intervalMs, ...dependencies]);

  return { isSyncing, error };
};

export default usePolling;
